import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AppDescribtionPage } from '../../AppDescribtion/AppDescribtion';
import { InAppBrowser } from 'ionic-native';
import { ChilanNewsPage } from '../ChilanNews/ChilanNews';


/*
  Generated class for the ChilanHome page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-ChilanHome',
    templateUrl: 'ChilanHome.html'
})
export class ChilanHomePage {

    constructor(public navCtrl: NavController, public navParams: NavParams) { }

    News() {
        this.navCtrl.push(ChilanNewsPage);
    }
    onLink(url: string) {
        window.open(url, '_system');
        //const browser = new InAppBrowser(url, '_system', 'location=yes');
        //browser.show();
        //browser.close();
    }
    onApp(url: string) {
        window.open(url, '_self');
        //const browser = new InAppBrowser(url, '_system', 'location=yes');
        //browser.show();
        //browser.close();
    }
    Book() {
        this.navCtrl.push(AppDescribtionPage, { Title: "کتاب سال فولاد", Color: "yellow", Text: "ChilanBook.txt" });
    }
    About() {
        this.navCtrl.push(AppDescribtionPage, { Title: "درباره چیلان", Color: "yellow", Text: "ChilanAbout.txt" });
    }
}



// WEBPACK FOOTER //
// ./src/pages/chilan/ChilanHome/ChilanHome.ts